import {z} from 'zod';

export const UserRoleEnumSchema = z.enum(['admin', 'member']);

const UserAccessRulesSchema = z.array(
  z.object({
    name: z.string(),
    values: z.array(z.string())
  })
);

export const UserRoleSchema = z.array(
  z.object({
    role: UserRoleEnumSchema,
    accessRules: UserAccessRulesSchema.optional()
  })
);

export const GetUserRoleRequestSchema = z.void();
export const GetUserRoleResponseSchema = UserRoleSchema;
